import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('PurchaseOrderDetails', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  purchaseOrderDetails: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  async loadDetails ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`purchase-orders/${payload.id}/details`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async checkBalanceByOrder ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`purchase-orders/check-balance-by-order`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_order', text: 'Balance actualizado', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.finish()
    }
  },
  async updateQuantities ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`/purchase-order-details/update-quantities-by-id`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.purchase_order', text: 'Cantidades Actualizadas', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      commit('SET_LOADING', false, { root: true })
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  purchaseOrderDetails: state => state.purchaseOrderDetails
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
